import { render, staticRenderFns } from "./oil_addoredit.vue?vue&type=template&id=373270f6&"
import script from "./oil_addoredit.vue?vue&type=script&lang=js&"
export * from "./oil_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports